module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:250',
      "data-vv-name": "units",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('units'),
      "type": "number",
      "label": _vm.$t('message.labelUnits'),
      "hintText": ((_vm.$t('message.cardInsulin')) + " " + _vm.lowerCaseUnitsLabel),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.units),
      callback: function($$v) {
        _vm.$set(_vm.reading, "units", _vm._n($$v))
      },
      expression: "reading.units"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "$t('message.selectText')",
      "data-vv-rules": 'required',
      "data-vv-name": "insulin_type",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('insulin_type'),
      "label": _vm.$t('message.labelInsulinType'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.type),
      callback: function($$v) {
        _vm.$set(_vm.reading, "type", $$v)
      },
      expression: "reading.type"
    }
  }, _vm._l((_vm.insulinTypes), function(type, index) {
    return _c('mu-menu-item', {
      key: 'insulin-type-' + index,
      attrs: {
        "value": type.insulin_type_id,
        "title": _vm.mapInsulinTypes(type.type)
      }
    })
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd530f60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Edit/Insulin/InsulinEdit.vue
// module id = 3835
// module chunks = 1